import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { ReactComponent as DiscordLogo } from '../../assets/img/discord-logo.svg';

export const DiscordLogoIcon = styled(DiscordLogo)`
  width: 90px;
  cursor: pointer;
`;

export const StyledNavLinks = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex !important;
  align-items: center;
  text-decoration: none;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12.642px;
  line-height: 100%;
  letter-spacing: 0.02em;
  display: block;
  transition: 0.3s;
  margin: 0;
  padding: 14px 21px;
  user-select: none;

  @media only screen and (max-width: 1199px) {
    margin: 0;
    padding: 13px 21px;
    flex-direction: row;
    justify-content: flex-start;
  }
  &.blocked {
    pointer-events: none;
    opacity: 0.3;
  }
  /*   &.selected {
    background: #383838;
    pointer-events: none;
    color: #ffffff;
    span {
      color: #ffffff;
      opacity: 1;
    }
    // TODO fix icon later
    #cup_icon {
      path {
        fill: #fff;
      }
    }
  } */
`;

export const StyledTextNavLink = styled(StyledNavLinks)`
  padding: 5px;
  text-align: center;
  cursor: pointer;
  color: #333333;
  font-size: 14px;
  padding: 15px;
  text-transform: none;
  letter-spacing: 0.01em;
  font-stretch: normal;
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
  @media only screen and (max-width: 1199px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 11px 12px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.78);
    font-size: 14px;
    text-transform: none;
    letter-spacing: 0.01em;
  }
`;
export const StyledAvatarContainer = styled.span`
  min-width: 40px;
  padding: 10px 12px;
  line-height: 10px;
  margin-right: 10px;
`;

export const StyledName = styled.span`
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
`;

export const StyledDropdownList = styled.ul`
  list-style: none;
  @media only screen and (max-width: 1199px) {
    width: 100%;
    border-top: 0;
    padding: 0 8px;
  }
`;

export const StyledAvatar = styled.img`
  max-width: 45px;
  border-radius: 50%;
`;

export const StyledTitle = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.border};
  padding: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledItem = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: ${({ isAuthenticated, theme }) =>
    isAuthenticated ? theme.textMuted : theme.textFaint};
  font-size: 14px;
  padding: 15px;
  ${({ isDefaultStyles, theme }) => {
    if (isDefaultStyles) {
      return css`
        color: ${theme.textMuted};
      `;
    }
  }}
  &:hover {
    background-color: ${({ isAuthenticated, theme }) =>
      !isAuthenticated ? theme.surface : theme.surfaceHover};
  }

  @media only screen and (max-width: 1199px) {
    padding: 11px 12px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.78);
    font-size: 14px;
    &:hover {
      background-color: ${({ theme }) => theme.headerControl};
    }
  }
`;

export const StyledFooter = styled.li`
  cursor: pointer;
  border-top: 1px solid ${({ theme }) => theme.border};
  padding: 15px;
  font-size: 14px;
  color: ${({ isAuthenticated, theme }) =>
    isAuthenticated ? theme.danger : theme.textFaint};
  &:hover {
    background-color: ${({ isAuthenticated, theme }) =>
      !isAuthenticated ? theme.surface : theme.surfaceHover};
  }
  @media only screen and (max-width: 1199px) {
    margin-top: 4px;
    padding: 11px 12px;
    border-top: 0;
    border-radius: 10px;
    font-weight: 600;
    &:hover {
      background-color: ${({ theme }) => theme.headerControl};
    }
  }
`;

export const StyledThemeRow = styled.li`
  position: relative;
  z-index: 1;
  padding: 12px 15px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const StyledThemeLabel = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledThemeChoices = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 4px;
  overflow: visible;
`;

export const StyledThemeChoice = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  overflow: visible;
  color: ${({ $selected, theme }) =>
    $selected ? theme.text : theme.textFaint};
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
`;

export const StyledThemePreview = styled.span`
  display: block;
  width: 100%;
  height: 36px;
  border-radius: 6px;
  box-shadow: ${({ $selected, theme }) =>
    $selected
      ? `0 0 0 2px ${theme.card}, 0 0 0 4px ${theme.headerAccent}`
      : `0 0 0 1px ${theme.border}`};
`;

export const StyledThemeSwatch = styled.span`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  background: ${({ $page }) => $page};

  &::before {
    content: '';
    float: left;
    width: 22%;
    height: 100%;
    background: ${({ $rail }) => $rail};
  }

  &::after {
    content: '';
    float: left;
    width: 28%;
    height: 100%;
    background: ${({ $nav }) => $nav};
  }
`;

export const StyledLightGray = styled.div`
  position: relative;
  height: 60px;
  width: 170px;
  text-align: center;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0px;
    width: 170px;
    height: 60px;
    transform: skew(-25deg, 0);
    background: #fdfdfd;
    z-index: 1;
    @media only screen and (max-width: 1199px) {
      height: 50px;
      width: 100%;
    }
  }
`;

export const StyledDarkGray = styled.div`
  position: relative;
  height: 60px;
  width: 170px;
  text-align: center;
  margin-right: 30px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0px;
    width: 170px;
    height: 60px;
    transform: skew(-25deg, 0);
    background: #f6f6f6;

    z-index: 1;
    @media only screen and (max-width: 1199px) {
      height: 50px;
      width: 100%;
    }
  }
`;
